import React from 'react';
import AppImage from '@components/app-image/app-image.tsx';
import AppMedia from '@components/app-media/app-media.tsx';
import { ScreenMediaPreviewProps } from '@modules/digital-signage/model/screen-media-preview.model.ts';
import { MediaTypeEnum } from '@modules/digital-signage/model/screens.model.ts';

const COMMON_STYLE = {
  width: '100%',
  height: '100%',
  objectFit: 'contain' as const
};

const ScreenMediaPreview: React.FC<ScreenMediaPreviewProps> = ({ screen }) => {
  if (!screen || (!screen.media && !screen.mediaUrl)) return null;

  switch (screen.mediaType) {
    case MediaTypeEnum.Image:
      return (
        <AppImage
          objectFit="cover"
          imgClassName="h-full"
          filePath={screen.media || undefined}
        />
      );
    case MediaTypeEnum.Video:
      return (
        <AppMedia
          type="video"
          filePath={screen.media || undefined}
          controls={false}
          style={{ ...COMMON_STYLE, backgroundColor: 'black' }}
        />
      );
    case MediaTypeEnum.Html:
    default:
      return (
        <AppMedia
          type="iframe"
          className="!w-full !h-full"
          filePath={screen.mediaUrl ? undefined : screen.media || undefined}
          previewSrc={screen.mediaUrl || undefined}
          style={COMMON_STYLE}
        />
      );
  }
};

export default ScreenMediaPreview;
